function findIndexOfNearestOption(value, options) {
  let minimumInterval = 99999999;
  let indexWithMinInterval = -1;
  let counter = 0;
  while (counter < options.length && minimumInterval > Math.abs(value - options[counter])) {
    minimumInterval = Math.abs(value - options[counter]);
    indexWithMinInterval = counter;
    counter++;
  }
  if (indexWithMinInterval === -1) return;
  return indexWithMinInterval;
}
export {
  findIndexOfNearestOption
};
//# sourceMappingURL=findIndexOfNearestOption.js.map
